import {
  BookingsResponseModel,
  ConfirmBookingInputModel,
  RejectBookingInputModel,
  CancelBookingInputModel,
  HideBookingInputModel,
  RequestBookingInputModel,
  DisputeInputModel,
  GetBookingsByIdsInputModel,
} from '../types/BookingModels';
import { api } from './api';

export const getBookings = async (
  token: string
): Promise<BookingsResponseModel | null> => {
  try {
    const response = await api.get<BookingsResponseModel>(`/v1/booking`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw error;
  }
};

export const getBookingById = async (
  id: string,
  token: string
): Promise<BookingsResponseModel | null> => {
  try {
    const response = await api.get<BookingsResponseModel>(`/v1/booking/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching booking:', error);
    throw error;
  }
};

export const requestBooking = async (
  model: RequestBookingInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/booking/request`, model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
};

export const confirmBooking = async (
  model: ConfirmBookingInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/booking/confirm`, model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error confirming booking:', error);
    throw error;
  }
};

export const declineBooking = async (
  model: RejectBookingInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/booking/reject`, model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error rejecting booking:', error);
    throw error;
  }
};

export const cancelBooking = async (
  model: CancelBookingInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/booking/cancel`, model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
};

export const raiseDispute = async (
  model: DisputeInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/dispute/create-dispute`, model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error raising dispute for booking:', error);
    throw error;
  }
};

export const hideBooking = async (
  model: HideBookingInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/booking/hide`, model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
};

export const getBookingsByIds = async (
  model: GetBookingsByIdsInputModel,
  token: string
): Promise<BookingsResponseModel> => {
  try {
    const response = await api.post<BookingsResponseModel>(
      `/v1/booking/by-ids`,
      model,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings by IDs:', error);
    throw error;
  }
};

export const notifyBookingRequest = async (
  professionalId: string,
  token: string
): Promise<void> => {
  try {
    await api.post(`/v1/notification/booking-request/${professionalId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error notifying booking request:', error);
    throw error;
  }
};
